<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('feedback.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="msg-box">
                <van-field
                    v-model="message"
                    rows="6"
                    size="large"
                    type="textarea"
                    maxlength="100"
                    :placeholder="$t('feedback.prop')"
                    show-word-limit
                />
            </div>
            <div class="phone-box">
                <van-field v-model="phone" :label="$t('feedback.contact')" input-align="right" :placeholder="$t('feedback.contactValue')" />
            </div>
            <div class="btn-disable" :class="{'able':message.length > 0}" @click="send">{{ $t('feedback.submit') }}</div>
        </div>
    </div>

</template>

<script>
    import { Toast } from 'vant';
    import {WebJSBridge} from "../../utils/JSBridge1";
    export default {
        name: '01feedback',
        data() {
            return {
                theme: 'light',
                message: '',
                phone: '',
                appVersion: '',
                termModel: '',
                termVersion: '',
                watchModel: ''
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme;
            }
            this.appVersion = this.$route.query.appVersion;
            this.termModel = this.$route.query.termModel;
            this.termVersion = this.$route.query.termVersion;
            this.watchModel = this.$route.query.watchModel;
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            send() {
                if (this.message) {
                    this.$api.my.uploadAppLog({
                        appVersion: this.appVersion,
                        describe: this.message,
                        phone: this.phone,
                        termModel: this.termModel,
                        termVersion: this.termVersion,
                        watchModel: this.watchModel
                    }).then(res => {
                        Toast.success('提交成功');
                        this.message = '';
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .msg-box {
        width: 345px;
        height: 189px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 11px auto 0;
        overflow: hidden;
        font-size: 15px;
    }

    .phone-box {
        width: 345px;
        height: 56px;
        background: var(--bg-color-2);
        border-radius: 10px 10px 10px 10px;
        margin: 20px auto 0;
        overflow: hidden;
    }

    /deep/ .van-cell {
        padding: 16px 20px;
        background-color: var(--bg-color-2);
    }

    .btn-disable {
        width: 345px;
        height: 52px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 74px auto;
        color: var(--text-color-3);
        justify-content: center;
        display: flex;
        align-items: center;
        font-size: 17px;
        border: 2px solid var(--bg-color-2);
    }

    /deep/ .van-field__label {
        color: var(--text-color-2);
    }

    /deep/ .van-field__control {
        font-size: 15px;
        color: var(--text-color-1);
    }

    .able {
        border: 2px solid var(--text-color-1);
        color: var(--text-color-1);
    }
</style>



// WEBPACK FOOTER //
// src/views/my/01feedback.vue